<template>
  <div class="product2">
    <!--1:banner-->
    <div class="block banner">
      <div :class="{content:true}">
        <div class="item1">
          <div class="box">
            <p :class="{title:true,animated:true,fadeInUp:isUp,delay1s:true}">渗透测试</p>
            <div :class="{detail:true,animated:true,fadeInUp:isUp,delay2s:true}">
              模拟黑客攻击对业务系统进行安全性测试，比黑客更早发现可导致企业数据泄露、资产受损、数据被篡改等漏洞，并协助企业进行修复。
            </div>
            <a :class="{btn:true,animated:true,fadeInUp:isUp,delay3s:true}" @click="goU('startApply')">立即申请</a>
          </div>
        </div>
      </div>
    </div>
    <!--2:service-->
    <div :class="{block:true, service:true}">
      <p :class="{title:true,animated:true,fadeInUp:isUp,delay5s:true}">服务优势</p>
      <div class="content">
        <ul :class="{ul_box:true, flex_between:true,animated:true,fadeInUp:isUp,delay6s:true}">
          <li class="flexCol_aroud">
            <div :class="{icon_wrap:true,}"><i class="icon icon1"></i></div>
            <h4 :class="{mid:true,}">团队可靠</h4>
            <div :class="{detail:true}">牛盾云渗透团队核心成员均具备十年以上的安全行业经验。</div>
          </li>
          <li class="flexCol_aroud">
            <div :class="{icon_wrap:true,}"><i class="icon icon2"></i></div>
            <h4 :class="{mid:true,}">安全可控</h4>
            <div :class="{detail:true,}">为用户定制完备的风险规避方案，保障测试业务中业务不受影响。</div>
          </li>
          <li class="flexCol_aroud">
            <div :class="{icon_wrap:true,}"><i class="icon icon3"></i></div>
            <h4 :class="{mid:true,}">报告分析</h4>
            <div :class="{detail:true,}">详细的渗透报告，提供复现漏洞方法及解决方案。</div>
          </li>
        </ul>
        <ul :class="{ul_box:true, flex_between:true,animated:false,fadeInUp:isUp2,displayNone:displayNone}" id="animateBox1">
          <li class="flexCol_aroud">
            <div :class="{icon_wrap:true,animated:true,fadeInUp:isUp2,delay1s:true}"><i class="icon icon4"></i></div>
            <h4 :class="{mid:true,animated:true,fadeInUp:isUp2,delay1s:true}">安全合规</h4>
            <div :class="{detail:true,animated:true,fadeInUp:isUp2,delay1s:true}">渗透相关资料数据严格保密，过程中涉及机密数据绝不获取。</div>
          </li>
          <li class="flexCol_aroud">
            <div :class="{icon_wrap:true,animated:true,fadeInUp:isUp2,delay1s:true}"><i class="icon icon5"></i></div>
            <h4 :class="{mid:true,animated:true,fadeInUp:isUp2,delay1s:true}">专家答疑</h4>
            <div :class="{detail:true,animated:true,fadeInUp:isUp2,delay1s:true}">用户直接对接专业技术人员，解答漏洞的形成原因和危害等技术问题。</div>
          </li>
          <li class="flexCol_aroud">
            <div :class="{icon_wrap:true,animated:true,fadeInUp:isUp2,delay1s:true}"><i class="icon icon6"></i></div>
            <h4 :class="{mid:true,animated:true,fadeInUp:isUp2,delay1s:true}">回归测试</h4>
            <div :class="{detail:true,animated:true,fadeInUp:isUp2,delay1s:true}">所有已检测出来漏洞，经修复后提供二次测试以确保修复成功。</div>
          </li>
        </ul>
      </div>
    </div>
    <!--3:apply-->
    <div :class="{block:true, apply:true,}">
      <p id="animateBox2" :class="{title:true,animated:false,fadeInUp:isUp3,displayNone:isDisplay3}">应用场景</p>
      <div class="content apply_swiper">
        <swiper :options="swiperOption" class="swiperContainer">
          <swiper-slide>
            <div class="slider slider1">
              <div class="slider_box">
                <div class="cont flexCol_aroud">
                  <h3 :class="{tit:true,}">网络渗透测试</h3>
                  <p :class="{detail:true,}">
                    模拟真实世界的攻击，发现对网络基础框架上的威胁。</p>
                  <h3 :class="{tit2:true,}">应用场景</h3>
                  <p :class="{detail:true,}">
                    企业的网络部署是决定安全边界的一个重要因素，如果不对其加强安全管理，那么安全也毫无保障。</p>
                </div>
                <div class="btn_wrap">
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
          <div class="slider slider2">
            <div class="slider_box">
              <div class="cont flexCol_aroud">
                <h3 class="tit">web 应用渗透测试</h3>
                <p class="detail">按照开源安全渗透方法手册(OSSTMM)渗透测试执行标准，开放式Web 应用安全项目，全面的评估Web 应用的安全性。</p>
                <h3 class="tit2">应用场景</h3>
                <p class="detail">Web 应用是对外服务的主要接口，其稳定性和安全性尤为重要。Web 组件版本众多，策略配置和本身的应用可能存在安全隐患，导致系统无法正常服务，数据泄露等安全问题。</p>
              </div>
              <div class="btn_wrap">
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
            </div>
          </div>
        </swiper-slide>
          <swiper-slide>
          <div class="slider slider3">
            <div class="slider_box">
              <div class="cont flexCol_aroud">
                <h3 class="tit">移动应用渗透测试</h3>
                <p class="detail">寻找和发现API 和web 程序在移动平台上的风险，以及APP 安全的测试。</p>
                <h3 class="tit2">应用场景</h3>
                <p class="detail">移动服务端应确保应用APP 与API 之间的安全通信，防止数据被恶意篡改等，同时要确保被第三方app 劫持数据的风险。</p>
              </div>
              <div class="btn_wrap">
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
            </div>
          </div>
        </swiper-slide>
          <swiper-slide>
          <div class="slider slider4">
            <div class="slider_box">
              <div class="cont flexCol_aroud">
                <h3 class="tit">物联网设备渗透测试</h3>
                <p class="detail">对商业物联网（IOT）设备进行安全测试，发现您所使用设备中固件，硬件，接口可能存在的安全问题。</p>
                <h3 class="tit2">应用场景</h3>
                <p class="detail">企业路由器、硬件安全设备、摄像头、门禁等，都可能存在固件版本低，权限提升，未授权访问等问题。</p>
              </div>
              <div class="btn_wrap">
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
            </div>
          </div>
        </swiper-slide>
          <swiper-slide>
          <div class="slider slider5">
            <div class="slider_box">
              <div class="cont flexCol_aroud">
                <h3 class="tit">社会工程学渗透测试</h3>
                <p class="detail">通过人员与通信进行相关脆弱性进行评估，例如通过冒充可信赖的人或者通过网络钓鱼攻击等方式获取机密信息等。</p>
                <h3 class="tit2">应用场景</h3>
                <p class="detail">企业人员的安全意识薄弱，家用网络及设备安全性无法保障，导致数据泄露等安全问题。</p>
              </div>
              <div class="btn_wrap">
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
            </div>
          </div>
        </swiper-slide>
          <div class="pag" slot="pagination"><p class="icon_pag"></p></div>
        </swiper>
      </div>
    </div>
    <!--4:banner-->
    <div :class="{block:true, serviceP:true,animated:true,fadeInUp:isUp4,displayNone:isDisplay4}" id="animateBox3">
      <p :class="{title:true,animated:true,fadeInUp:isUp4}">服务流程</p>
      <div class="content">
        <div :class="{top:true, flex:true,animated:true,fadeInUp:isUp4,delay1s:true}">
          <div class="parent"><span class="icon icon_circle1"></span></div>
          <i class="icon icon_right"></i>
          <div class="parent"><span class="icon icon_circle2"></span></div>
          <i class="icon icon_right"></i>
          <div class="parent"><span class="icon icon_circle3"></span></div>
          <i class="icon icon_right"></i>
          <div class="parent"><span class="icon icon_circle4"></span></div>
          <i class="icon icon_right"></i>
          <div class="parent"><span class="icon icon_circle5"></span></div>
        </div>
        <ul class="box flex_between">
          <li>
            <div class="title_wrap"><h3 :class="{titleT:true,animated:true,fadeInUp:isUp4,delay2s:true}">获取授权书</h3></div>
            <div class="box_cont flexCol_between">
              <span :class="{detail:true,animated:true,fadeInUp:isUp4,delay3s:true}">明确时间、目标，风险等。</span>
              <div class="icon_wrap"><i class="iconTree"></i></div>
            </div>
          </li>
          <li>
            <div class="title_wrap"><h3 :class="{titleT:true,animated:true,fadeInUp:isUp4,delay2s:true}">项目启动</h3></div>
            <div class="box_cont flexCol_between">
              <span :class="{detail:true,animated:true,fadeInUp:isUp4,delay3s:true}">确定目标、脆弱性分析、任务拆分、确定渗透测试方向。</span>
              <div class="icon_wrap"><i class="iconTree iconTree1"></i></div>
            </div>
          </li>
          <li>
            <div class="title_wrap"><h3 :class="{titleT:true,animated:true,fadeInUp:isUp4,delay2s:true}">项目执行</h3></div>
            <div class="box_cont flexCol_between">
              <span :class="{detail:true,animated:true,fadeInUp:isUp4,delay3s:true}">物联网设备、社会工程学、web应用、移动应用、网络。</span>
              <div class="icon_wrap"><i class="iconTree iconTree2"></i></div>
            </div>
          </li>
          <li>
            <div class="title_wrap"><h3 :class="{titleT:true,animated:true,fadeInUp:isUp4,delay2s:true}">生成报告</h3></div>
            <div class="box_cont flexCol_between">
              <span :class="{detail:true,animated:true,fadeInUp:isUp4,delay3s:true}">报告汇总，汇总系统风险评估结果和漏洞，发送测试报告。</span>
              <div class="icon_wrap"><i class="iconTree iconTree3"></i></div>
            </div>
          </li>
          <li>
            <div class="title_wrap"><h3 :class="{titleT:true,animated:true,fadeInUp:isUp4,delay2s:true}">专家答疑</h3></div>
            <div class="box_cont flexCol_between">
              <span :class="{detail:true,animated:true,fadeInUp:isUp4,delay3s:true}">专家一对一解决问题，提供技术支持和解决方案。</span>
              <div class="icon_wrap"><i class="iconTree iconTree4"></i></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--5:case-->

    <div :class="{block:true,case:true,animated:true,fadeInUp:isUp4,displayNone:isDisplay5}" id="animateBox4">
      <p :class="{title:true,animated:true,fadeInUp:isUp5}">行业案例</p>
      <div :class="{content:true}">
        <ul class="item flex_between">
          <li>
            <div :class="{box:true, flexCol_center:true,animated:true,fadeInUp:isUp5,delay1s:true}"><i class="icon icon1"></i></div>
            <h4 :class="{title_detail:true,animated:true,fadeInUp:isUp5,delay2s:true}">新网银行</h4>
          </li>
          <li>
            <div :class="{box:true, flexCol_center:true,animated:true,fadeInUp:isUp5,delay1s:true}"><i class="icon icon2"></i></div>
            <h4 :class="{title_detail:true,animated:true,fadeInUp:isUp5,delay2s:true}">众安保险</h4>
          </li>
          <li>
            <div :class="{box:true, flexCol_center:true,animated:true,fadeInUp:isUp5,delay1s:true}"><i class="icon icon3"></i></div>
            <h4 :class="{title_detail:true,animated:true,fadeInUp:isUp5,delay2s:true}">台州政府</h4>
          </li>
          <li>
            <div :class="{box:true, flexCol_center:true,animated:true,fadeInUp:isUp5,delay1s:true}"><i class="icon icon4"></i></div>
            <h4 :class="{title_detail:true,animated:true,fadeInUp:isUp5,delay2s:true}">夏娃科技</h4>
          </li>
          <li>
            <div :class="{box:true, flexCol_center:true,animated:true,fadeInUp:isUp5,delay1s:true}"><i class="icon icon5"></i></div>
            <h4 :class="{title_detail:true,animated:true,fadeInUp:isUp5,delay2s:true}">杭州妇幼保健院</h4>
          </li>
        </ul>
      </div>
    </div>

    <!--foot-->
    <div class="foot">
      <footBar></footBar>
    </div>
    <!--返回顶部-->
    <returnTop></returnTop>
  </div>
</template>

<script>
  import footBar from '../../components/footerbar'
  import Case from '../../components/case'
  import returnTop from '../../components/returnTop'

  export default {
    name: "product2",
    data() {
      return {
        swiperOption: {
          autoplay: true,
          speed: 500,
          loop: true,
          type:'custom',
          navigation: {
            nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
            prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          },
          pagination: {
            el: '.pag',
            bulletElement: "li",

          }
        },
        isUp: false,
        isUp2: false,
        isUp3: false,
        isUp4: false,
        isUp5: false,
        displayNone: true,
        isDisplay3: true,
        isDisplay4: true,
        isDisplay5: true,
      }
    },
    components: {
      footBar, Case,returnTop
    },
    mounted() {
      this.isUp = true;
      window.addEventListener('scroll', this.scrollFun);
    },
    destroyed(){
      window.removeEventListener('scroll',this.scrollFun);
    },
    methods: {
      scrollFun() {
        let animateBox1 = document.getElementById('animateBox1');
        let animateBox2 = document.getElementById('animateBox2');
        let animateBox3 = document.getElementById('animateBox3');
        let animateBox4 = document.getElementById('animateBox4');
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;//窗口滚动条滚动高度
        let scrollDiv1 = animateBox1.offsetTop - scrollTop;
        let scrollDiv2 = animateBox2.offsetTop - scrollTop;
        let scrollDiv3 = animateBox3.offsetTop - scrollTop;
        let scrollDiv4 = animateBox4.offsetTop - scrollTop;

        if (scrollDiv1 <= 700) {
          this.isUp2 = true;
          this.displayNone = false;
        }
        if (scrollDiv2 <= 700) {
          this.isDisplay3 = false;
          this.isUp3 = true;
        }
        if (scrollDiv3 <= 700) {
          this.isDisplay4 = false;
          this.isUp4 = true;
        }
        if (scrollDiv4 <= 700) {
          this.isDisplay5 = false;
          this.isUp5 = true;
        }
      },
      goU(url){
        this.$router.push({name:url,params:{product:0,title:'渗透测试'}});
      },
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/product/product2.vue